<template>
  <div class="fill-height">
    <v-layout row wrap>
      <v-flex>
        <section>
          <v-img
            width="100%"
            height="100vh"
            alt="humax"
            class="login-bg"
            gradient="to top right, rgba(27, 154, 170, 0.22), rgba(27, 154, 170, 0.12)"
            :src="require('@/assets/background/bg-image.jpg')">
            <v-row
              align="center"
              justify="center"
              style="min-height: 100vh;">
              <v-col
                cols="12"
                sm="8"
                md="5"
                lg="4">
                <v-card
                  elevation="0"
                  color="transparent">
                  <div>
                    <v-card
                      class="login-card"
                      color="white">
                      <v-card-text
                        class="pa-8 pa-md-10">
                        <div class="text-center mb-6">
                          <v-avatar size="56" class="mb-3 logo-ring">
                            <v-img :src="require('@/assets/logo/favicon_color.png')" contain></v-img>
                          </v-avatar>
                          <div class="headline font-weight-bold login-title">
                            Selamat Datang
                          </div>
                          <div class="caption login-subtitle">
                            Humax Dashboard
                          </div>
                        </div>

                        <ValidationObserver 
                          ref="observer">
                          <v-form class="text-left mb-6">
                            <ValidationProvider 
                              name="Email" 
                              rules="required|email" 
                              v-slot="{ errors }">
                              <v-text-field
                                v-on:keyup.enter="save"
                                class="no_box"
                                outlined
                                color="#1b9aaa"
                                placeholder="Email"
                                prepend-inner-icon="mdi-email-outline"

                                vv-uppercase

                                v-model="form.username"
                                :error-messages="errors"
                                required>
                              </v-text-field>
                            </ValidationProvider>

                            <ValidationProvider 
                              name="Password" 
                              rules="required|min:5|max:20" 
                              v-slot="{ errors }">
                              <v-text-field
                                v-on:keyup.enter="save"
                                class="no_box"
                                outlined
                                color="#1b9aaa"
                                placeholder="Password"
                                :type="show ? 'text' : 'password'"
                                prepend-inner-icon="mdi-lock-outline"
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="show = !show"
                                :counter="20"

                                vv-uppercase
                                
                                v-model="form.password"
                                :error-messages="errors"
                                required>
                              </v-text-field>
                            </ValidationProvider>
                          </v-form>
                        </ValidationObserver>

                        <div 
                          class="text-center mb-6">
                          <div v-if="message.error.length > 0"
                            class="text-center my-4">
                            <div
                              class="error--text d-flex align-start justify-center">
                              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                              
                              <span
                                class="ml-1">
                                {{ message.error }}
                              </span>
                            </div>
                          </div>

                          <v-btn
                            v-on:keyup.enter="save"
                            :disabled="process.form"
                            :loading="process.form"
                            @click="save"
                            block
                            large
                            height="52"
                            elevation="1"
                            class="title font-weight-bold white--text text-capitalize login-btn">
                            Masuk Sekarang
                          </v-btn>
                        </div>

                        <v-row no-gutters align="center" class="mt-2">
                          <v-col cols="12" class="text-center">
                            <span class="caption black--text">
                              Lupa password?
                            </span>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-img>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        await get('config')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data[0].color = JSON.parse(res.results.data[0].color)

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])
            
            if (res.results.data[0].color.length > 0) {
              res.results.data[0].color.map((obj) => {
                if (obj.active) {
                  TokenService.saveColor(obj.hex)

                  this.$store.commit("setColor", obj.hex)
                }
              })
            } else {
              TokenService.saveColor('#7550e1')

              this.$store.commit("setColor", '#7550e1')
            }
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('admin/auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              let user = res.results.data,
                  menu = [
                    {
                      title: 'Dashboard',
                      icon: require('@/assets/icon/dashboard.png'),
                      link: '/dashboard',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Statistik',
                          icon: require('@/assets/icon/audit.png'),
                          link: '/dashboard',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Monitoring',
                          icon: require('@/assets/icon/monitor.png'),
                          link: '/monitoring',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Audit Trail',
                          icon: require('@/assets/icon/audit.png'),
                          link: '/audit',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Organisasi',
                      icon: require('@/assets/icon/struktur.png'),
                      link: '/unit',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Struktur Organisasi',
                          link: '/unit/structure',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Struktur Jabatan',
                          icon: require('@/assets/icon/posisi.png'),
                          link: '/unit/position',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Aturan Perusahaan',
                          icon: require('@/assets/icon/doc.png'),
                          link: '/unit/doc',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Pegawai',
                      icon: require('@/assets/icon/user.png'),
                      link: '/user',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Data Pegawai',
                          icon: require('@/assets/icon/user.png'),
                          link: '/user',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Presensi Pegawai',
                          icon: require('@/assets/icon/absen.png'),
                          link: '/attendance',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Lembur Pegawai',
                          icon: require('@/assets/icon/lembur.png'),
                          link: '/overtime',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Perizinan Pegawai',
                          icon: require('@/assets/icon/ijin_menu.png'),
                          link: '/permission',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Cuti Pegawai',
                          icon: require('@/assets/icon/ijin_menu.png'),
                          link: '/licensing',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Laporan Pegawai',
                          icon: require('@/assets/icon/laporan.png'),
                          link: '/report',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Keuangan',
                      icon: require('@/assets/icon/gaji.png'),
                      link: '/salary',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Informasi Gaji',
                          link: '/salary/now',
                          active: false,
                          sub_child: [
                            {
                              title: 'Riwayat Gaji',
                              link: '/salary',
                              active: false
                            },
                            {
                              title: 'Konfigurasi Komponen',
                              link: '/salconfig',
                              active: false
                            }
                          ]
                        },
                        {
                          title: 'Reimbursment',
                          icon: require('@/assets/icon/reimburs.png'),
                          link: '/reimbursement',
                          active: false,
                          sub_child: [
                            {
                              title: 'Data Reimburs',
                              link: '/reimbursement',
                              active: false
                            },
                            {
                              title: 'Konfigurasi Komponen',
                              link: '/reimbconfig',
                              active: false
                            }
                          ]
                        }
                      ]
                    },
                    {
                      title: 'General Affair',
                      icon: require('@/assets/icon/general.png'),
                      link: '/afair',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Agenda',
                          icon: require('@/assets/icon/event.png'),
                          link: '/event',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Pengumuman',
                          icon: require('@/assets/icon/pengumuman.png'),
                          link: '/announcement',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Kinerja Pegawai',
                      icon: require('@/assets/icon/indicator.png'),
                      link: '/kpi',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Penilaian Pegawai',
                          link: '/kpi/nilai',
                          active: false,
                          sub_child: [
                            // {
                            //   title: 'Tugas Utama',
                            //   link: '/kpi/nilai/tugas_utama',
                            //   active: false
                            // },
                            // {
                            //   title: 'Pengembangan Diri',
                            //   link: '/kpi/nilai/pengembangan_diri',
                            //   active: false
                            // },
                            // {
                            //   title: 'Summary Skor',
                            //   link: '/kpi/nilai/summary_score',
                            //   active: false
                            // }
                          ]
                        },
                        {
                          title: 'Master Kuisoner',
                          link: '/kpi/master/kuisoner',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Master Kategori Penilaian',
                          link: '/kpi/master/category',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Perusahaan',
                      icon: require('@/assets/icon/company.png'),
                      link: '/setting/company',
                      active: false,
                      sub_menu: []
                    }
                  ]

              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu)
              )

              TokenService.saveReload(false)

              window.location = `${process.env.BASE_URL}dashboard`
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
.login-bg {
  position: relative;
  overflow: hidden; /* prevent stray horizontal overflow */
}
.login-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  /* Remove blur; keep a subtle color wash for contrast */
  background: linear-gradient(0deg, rgba(27,154,170,0.08), rgba(27,154,170,0.04));
  pointer-events: none; /* allow clicks to pass through */
}

.login-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.12);
  position: relative;
}

/* .login-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: #1b9aaa;
} */

.logo-ring {
  background: #e9f6f8;
  box-shadow: 0 4px 12px rgba(27,154,170,0.25);
}

.login-title {
  color: #0b3b40;
}

.login-subtitle {
  color: #5f7b7e;
}

.input-elevated {
  border-radius: 12px !important;
  box-shadow: 0 6px 14px rgba(0,0,0,0.06);
}

.field-hint {
  color: #6b7f81;
}

.login-btn {
  background: #1b9aaa !important;
  transition: filter 0.2s ease, transform 0.02s ease;
  border-radius: 10px;
}

.login-btn:hover {
  filter: brightness(1.05);
}

.login-btn:active {
  transform: translateY(1px);
}
</style>